import { render, staticRenderFns } from "./cuSMSTemplate.vue?vue&type=template&id=8b5554f8&scoped=true"
import script from "./cuSMSTemplate.vue?vue&type=script&lang=js"
export * from "./cuSMSTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b5554f8",
  null
  
)

export default component.exports